import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Briefcase, Plus, Search as SearchIcon, Users, MessageCircle, Box, Video, Calendar, Building2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const isStudent = (user?.profile_type || "").toLowerCase() === "student";
  const [showCreateOptions, setShowCreateOptions] = useState(false);
  const [showSocialOptions, setShowSocialOptions] = useState(false);

  // Analytics Helper
  const trackEvent = (action: string, category: string, label?: string) => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', action, {
        event_category: category,
        event_label: label
      });
    }
  };

  // Close dropdowns on route change
  useEffect(() => {
    setShowCreateOptions(false);
    setShowSocialOptions(false);
  }, [location.pathname, location.search]);

  const active = {
    home: location.pathname === "/home",
    opportunities: location.pathname === "/opportunities",
    search: location.pathname === "/search",
    invideo: location.pathname === "/invideo",
  };

  const baseBtn = "flex flex-col items-center justify-center space-y-1 transition-colors rounded-lg mx-1 min-h-[44px] py-2";

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-30">
      {/* Create options pop-up (non-students) */}
      {!isStudent && showCreateOptions && (
        <div className="absolute bottom-full left-0 right-0 bg-white border border-gray-200 shadow-xl rounded-t-2xl">
          <div className="grid grid-cols-1 gap-2 p-3">
            <button
              onClick={() => {
                trackEvent('mobile_nav_click', 'Create_Popup', 'Post_Home');
                navigate("/home?create=post");
              }}
              className="w-full p-4 border border-gray-200 rounded-lg hover:border-blue-600 hover:bg-blue-50 text-left"
            >
              <div className="font-medium text-gray-900">Post on Home</div>
              <div className="text-xs text-gray-600">Share text and images with your network</div>
            </button>
            <button
              onClick={() => {
                trackEvent('mobile_nav_click', 'Create_Popup', 'Post_Opportunity');
                navigate("/opportunities?create=opportunity");
              }}
              className="w-full p-4 border border-gray-200 rounded-lg hover:border-blue-600 hover:bg-blue-50 text-left"
            >
              <div className="font-medium text-gray-900">Post an Opportunity</div>
              <div className="text-xs text-gray-600">Create an internship, job, hackathon, scholarship, etc.</div>
            </button>
          </div>
        </div>
      )}


      <div className="grid grid-cols-5 h-16 gap-1 px-1">
        {/* Home */}
        <button
          onClick={() => {
            trackEvent('mobile_nav_click', 'Bar', 'Home');
            navigate("/home");
          }}
          className={`${baseBtn} ${active.home ? "text-blue-500 bg-gray-50 font-medium" : "text-gray-600 hover:text-blue-500 hover:bg-gray-50"}`}
        >
          <Home className="h-5 w-5" />
          <span className="text-xs">Home</span>
        </button>

        {/* Opportunities */}
        <button
          onClick={() => {
            trackEvent('mobile_nav_click', 'Bar', 'Opportunities');
            navigate("/opportunities");
          }}
          className={`${baseBtn} ${active.opportunities ? "text-blue-500 bg-gray-50 font-medium" : "text-gray-600 hover:text-blue-500 hover:bg-gray-50"}`}
        >
          <Briefcase className="h-5 w-5" />
          <span className="text-xs">Opportunities</span>
        </button>

        {/* InVideo - CENTER */}
        <button
          onClick={() => {
            trackEvent('mobile_nav_click', 'Bar', 'InVideo');
            navigate("/invideo");
          }}
          className={`${baseBtn} ${active.invideo ? "text-blue-500 bg-gray-50 font-medium" : "text-gray-600 hover:text-blue-500 hover:bg-gray-50"}`}
        >
          <Video className="h-5 w-5" />
          <span className="text-xs">InVideo</span>
        </button>

        {/* Events */}
        <button
          onClick={() => {
            trackEvent('mobile_nav_click', 'Bar', 'Events');
            navigate("/events");
          }}
          className={`${baseBtn} ${location.pathname === "/events" ? "text-blue-500 bg-gray-50 font-medium" : "text-gray-600 hover:text-blue-500 hover:bg-gray-50"}`}
        >
          <Calendar className="h-5 w-5" />
          <span className="text-xs">Events</span>
        </button>

        {/* Jobs */}
        <button
          onClick={() => {
            trackEvent('mobile_nav_click', 'Bar', 'Jobs');
            navigate("/jobs");
          }}
          className={`${baseBtn} ${location.pathname === "/jobs" ? "text-blue-500 bg-gray-50 font-medium" : "text-gray-600 hover:text-blue-500 hover:bg-gray-50"}`}
        >
          <Building2 className="h-5 w-5" />
          <span className="text-xs">Jobs</span>
        </button>
      </div>
    </div>
  );
}
